/* Grow Peaceful — global.js
   Mobile nav, AJAX add-to-cart, quantity steppers, product gallery,
   sticky add-to-cart bar, cart quantity updates. No dependencies. */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(html) {
    var el = document.getElementById('gp-toast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-site-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Nav dropdowns ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-dropdown-toggle]');
    if (toggle) {
      var item = toggle.closest('.has-dropdown');
      var open = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Close any sibling dropdowns
      document.querySelectorAll('.has-dropdown.is-open').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var t = other.querySelector('[data-dropdown-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      return;
    }
    // Click outside closes open dropdowns
    if (!e.target.closest('.has-dropdown')) {
      document.querySelectorAll('.has-dropdown.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var t = item.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.has-dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-dropdown-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var val = (parseInt(input.value, 10) || min) + step;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart count bubble ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var originalText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = button.getAttribute('data-adding-text') || 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          showToast(result.data.description || 'Could not add to cart.');
          return;
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showToast('Added to cart — <a href="/cart">view cart</a>');
          });
      })
      .catch(function () { showToast('Could not add to cart. Please try again.'); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = originalText; }
      });
  });

  /* ---------- Cart page: line quantity changes ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line-qty'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(line) || isNaN(qty) || qty < 0) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { showToast('Could not update cart.'); });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    main.src = thumb.getAttribute('data-gallery-thumb');
    var srcset = thumb.getAttribute('data-gallery-srcset');
    if (srcset) main.srcset = srcset;
    var alt = thumb.getAttribute('data-gallery-alt');
    if (alt !== null) main.alt = alt;
    document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* ---------- Variant selector → price / availability / URL ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var form = select.closest('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = select.value;

    var priceVal = option.getAttribute('data-price');
    if (priceVal) {
      document.querySelectorAll('[data-product-price]').forEach(function (el) {
        el.textContent = priceVal;
      });
    }
    var button = form.querySelector('[type="submit"]');
    if (button) {
      var available = option.getAttribute('data-available') === 'true';
      button.disabled = !available;
      button.textContent = available
        ? (button.getAttribute('data-add-text') || 'Add to cart')
        : (button.getAttribute('data-soldout-text') || 'Sold out');
    }
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url.toString());
    }
  });

  /* ---------- Sticky add-to-cart (product pages) ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('[data-main-product-form]');
  if (stickyBar && mainForm && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    observer.observe(mainForm);

    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var submit = mainForm.querySelector('[type="submit"]');
        if (submit && !submit.disabled) {
          mainForm.requestSubmit ? mainForm.requestSubmit() : submit.click();
        }
      });
    }
  }
})();
